module.exports = __webpack_public_path__ + "static/media/star_FFA200.d0626e52.svg";